var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid reviews"},_vm._l((['★', '★', '★', '★', '★']),function(v,i){return _c('span',{key:i,on:{"click":function($event){return _vm.handleClick(i + 1)}}},[_c('span',{staticClass:"rate-star",style:(i + 1 <= _vm.rate ? 'color: #ff4d00' : '')},[_vm._v("★")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }